import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";
import { ProposalProduct } from "generated/graphql";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import WorksheetItemRow from "./WorksheetItemRow";
import { worksheetTableGridTemplate } from "./worksheetStyles";

type WorksheetItemTableProps = {
  products: ProposalProduct[];
  expandedProductId: string | false;
  onToggleExpand: (id: string) => void;
  onDeleteProduct: (id: string) => void;
};

export default function WorksheetItemTable({
  products,
  expandedProductId,
  onToggleExpand,
  onDeleteProduct,
}: WorksheetItemTableProps) {
  return (
    <MDBox>
      <MDBox
        display="grid"
        gridTemplateColumns={worksheetTableGridTemplate}
        alignItems="center"
        sx={{
          backgroundColor: draftColors.surfaceMuted,
          borderTop: `1px solid ${draftColors.border}`,
          borderBottom: `1px solid ${draftColors.border}`,
          py: "8px",
        }}
      >
        <MDBox />
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "left",
          }}
        >
          Item Name
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Quantity
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Unit
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Unit Price
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Overhead %
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Indirect %
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Costs
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Profit
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Margin %
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Discount
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "right",
          }}
        >
          Total
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Optional
        </UiTypography>
        <UiTypography
          uiVariant="overline"
          sx={{
            background: "none",
            border: "none",
            px: "4px",
            fontSize: "10px",
            letterSpacing: "0.05em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Actions
        </UiTypography>
      </MDBox>

      {products.map((product) => (
        <WorksheetItemRow
          key={product.id}
          product={product}
          isExpanded={expandedProductId === product.id}
          onToggleExpand={onToggleExpand}
          onDeleteProduct={onDeleteProduct}
        />
      ))}
    </MDBox>
  );
}
